import React, { Component } from "react";
import "./Footer.css";

export class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <h1>★★★</h1>
      </div>
    );
  }
}

export default Footer;
